import { CurrencyUnknown } from '@/typings/api-models';
import type { Questionnaire } from '@/typings/Questionnaire';
import * as format from '@format';

const getDisplayValue = (
  subField: Pick<Questionnaire.Field, 'type' | 'options'>,
  value: unknown,
): string => {
  if (!value) return '—';

  if (subField.type === 'single-select' || subField.type === 'selection') {
    return subField.options?.find(o => o.key === value)?.label || '—';
  }

  if (subField.type === 'multi-select') {
    return (value as string[]).map(v => subField.options?.find(o => o.key === v)?.label || '—').join(', ');
  }

  if (subField.type === 'address-us' || subField.type === 'address-international') {
    return Object.values(value).filter(Boolean).join(', ') || '—';
  }

  if (subField.type === 'name') {
    const name = value as {
        firstName: string;
        middleName?: string;
        lastName: string;
      };
    return `${name.firstName}${name.middleName ? ` ${name.middleName} ` : ' '}${name.lastName}` || '—';
  }

  if (subField.type === 'currency') {
    return (
      value
        && typeof value === 'object'
        && 'amount' in value
        && typeof value.amount === 'number'
        && 'currency' in value
        && typeof value.currency === 'string'
    )
      ? format.price.withCurrency(value.amount, value.currency)
      : ((typeof value === 'object' && 'amount' in value && value?.amount) === CurrencyUnknown.Unknown ? 'Unknown' : '—');
  }

  if (subField.type === 'date') {
    return value && (value instanceof Date || typeof value === 'string' || typeof value === 'number')
      ? new Date(value).toLocaleDateString('default', {
        day: 'numeric',
        month: 'short',
        timeZone: 'UTC',
        year: 'numeric',
      })
      : '—';
  }

  return String(value);
};

export default getDisplayValue;